module.exports = __webpack_public_path__ + "img/2001_2005.26a14605.jpg";